import React, {useContext, useEffect} from "react";
import CustomPopup from "../../../../components/CustomPopup";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import './RewardThemeModal.css'
import {useMusicContext} from "../../../../providers/musicProvider/music-player-context.tsx";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    awardResult: string[];
}

// 徽章奖励
const RewardThemeModal: React.FC<Props> = ({isOpen, onClose, awardResult}) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    // 全局音乐provider
    const musicManager = useMusicContext();

    useEffect(() => {
        if(isOpen){
            musicManager.playSuccessSound()
        }
    }, [isOpen]);

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="medal-reward-theme-modal-container">
                <img onClick={onClose} className="medal-reward-modal-close-container z-index-5" src={imgUrls.closeBtnWhiteUrl}
                     alt="pic"/>
                {/*文字*/}
                <img src={imgUrls.awardDialogTextPic} alt="pic"
                     className="margin-top-26 height-20 width-245 margin-left-right-auto"/>
                {/*方形图片*/}
                <img src={imgUrls.awardDialogQuartPic} alt="pic"
                     className="position-absolute position-top-107 height-246 width-246"/>
                {/*光线背景*/}
                <img src={imgUrls.awardDialogRayPic} className="height-460 position-absolute rotate-image" alt="pic"/>
                {/*圆形光辉*/}
                <img src={imgUrls.awardDialogRoundPic} alt="pic"
                     className="position-absolute height-460 width-460 margin-left-right-auto"/>
                {/*星光背景*/}
                <img className="margin-top-30 height-276 img-no-repeat-center-contain width-400"
                     src={imgUrls.awardDialogStarPic} alt="pic"/>
                <div className="medal-reward-modal-card-container"
                     style={{backgroundImage: `url(${imgUrls.avatarFrameCardBg})`}}>

                    <div className="margin-top-30 margin-left-right-auto width-131 bg-color-white border-radius-6">
                        <img className="border-radius-6 width-131 height-131 margin-left-right-auto" src={awardResult[0]} alt="pic" />
                    </div>

                    {/*文字*/}
                    <div
                        className="position-absolute  width-246 position-bottom-33  my-roboto-medium font-size-16 display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                        <div className="width-180 margin-left-right-auto text-center">
                            Congratulations! You've received a reward!
                        </div>
                    </div>
                </div>
                {/*按钮*/}
                <div onClick={onClose}
                     className="width-133 border-radius-34 height-43 medal-reward-modal-ok-btn position-absolute position-bottom-36 display-flex-row display-flex-align-items-center display-flex-justify-content-center color-white my-roboto-medium font-size-16">
                    OK
                </div>
            </div>
        </CustomPopup>
    );
};
export default RewardThemeModal;